import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Components
import TextLoader from './TextLoader';
import ButtonLoader from './ButtonLoader';
import CircleLoader from './CircleLoader';
import FullPageLoader from './FullPageLoader';
import s from './Loader.css';

const Loader = ({
  type = 'text',
  children,
  show,
  loadingText,
  label,
  buttonType,
  handleClick,
  className,
  disabled,
  spinnerColor,
  containerClass,
  dropzoneLoaderClass,
  isSecondary
}) => {
  return (
    <div className={cx(containerClass)}>
      {type === 'text' && <TextLoader loadingText={loadingText} />}

      {type === 'page' && <FullPageLoader show={show} dropzoneLoaderClass={dropzoneLoaderClass} >{children}</FullPageLoader>}

      {type === 'button' && (
        <ButtonLoader
          label={label}
          show={show}
          type={buttonType}
          handleClick={handleClick}
          className={className}
          disabled={disabled}
          spinnerColor={spinnerColor}
          isSecondary={isSecondary}
        />
      )}

      {type === 'circle' && <CircleLoader show={show} />}
    </div>
  );
};

Loader.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node,
  show: PropTypes.bool,
  loadingText: PropTypes.string,
  label: PropTypes.string,
  buttonType: PropTypes.string,
  handleClick: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  spinnerColor: PropTypes.string,
  containerClass: PropTypes.string,
};

export default withStyles(s)(Loader);
